"use strict";

var _assertThisInitialized = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/get");

var _possibleConstructorReturn = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/inherits");

var _construct = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/construct");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/createClass");

var _toArray = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/toArray");

var _defineProperty = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("bitcoinsource");

var e = require("axios");

function n(t) {
  return t && "object" == typeof t && "default" in t ? t : {
    default: t
  };
}

var s = n(t);
var i = n(e);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function r(t, e) {
  var n = {};

  for (var s in t) {
    Object.prototype.hasOwnProperty.call(t, s) && e.indexOf(s) < 0 && (n[s] = t[s]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;

    for (s = Object.getOwnPropertySymbols(t); i < s.length; i++) {
      e.indexOf(s[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[i]) && (n[s[i]] = t[s[i]]);
    }
  }

  return n;
}

function o(t, e, n, s) {
  return new (n || (n = Promise))(function (i, r) {
    function o(t) {
      try {
        a(s.next(t));
      } catch (t) {
        r(t);
      }
    }

    function c(t) {
      try {
        a(s.throw(t));
      } catch (t) {
        r(t);
      }
    }

    function a(t) {
      var e;
      t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
        t(e);
      })).then(o, c);
    }

    a((s = s.apply(t, e || [])).next());
  });
}

var c = process.env.BC_CHAIN || "BSV";
var a = process.env.BC_NETWORK || "testnet";
var u = process.env.BC_WOC_API_KEY || void 0;
var d = parseInt(process.env.BC_DUST_LIMIT, 10) || 4e3;
var h = parseInt(process.env.BC_DEFAULT_FEE, 10) || ("BSV" === c ? 500 : 2500);
var p = parseInt(process.env.BC_SCRIPT_CHUNK_SIZE, 10) || 479;
var l;
var f;
process.env.BC_BBS_URL ? (f = "http://" + process.env.BC_BBS_URL, l = "ws://" + process.env.BC_BBS_URL) : (f = "https://bbs.bitcoincomputer.io", l = "wss://bbs.bitcoincomputer.io");
var g = {
  CHAIN: c,
  NETWORK: a,
  WOC_API_KEY: u,
  MIN_NON_DUST_AMOUNT: d,
  SCRIPT_CHUNK_SIZE: p,
  UN_P2SH_URL: f,
  WS_URL: l,
  DEFAULT_FEE: h
};
s.default.versionGuard = function () {
  return !0;
}, s.default.Networks.defaultNetwork = s.default.Networks[g.NETWORK];
var w = s.default.PublicKey;

var _ = function _() {
  return "__temp__:" + Math.random();
};

var v = ["_id", "_rev", "_owners", "_amount", "__vouts", "__txId", "__cls", "__func", "__index", "__args"];

var m = function m(t) {
  return Object.prototype.toString.call(t).match(/\s([a-zA-Z]+)/)[1];
};

var b = function b(t) {
  return "object" == typeof t ? m(t) : m(t).toLowerCase();
};

var y = function y(t) {
  return ["number", "string", "boolean", "undefined", "Null"].includes(b(t));
};

var O = function O(t) {
  return "Array" === b(t);
};

var S = function S(t) {
  return "Object" === b(t);
};

var x = function x(t) {
  return !!t._owners && "object" == typeof t._owners;
};

var I = function I(t) {
  return !!t._owners && "string" == typeof t._owners;
};

var j = function j(t) {
  return !!t._amount;
};

var P = function P(t) {
  return y(t) || ["Array", "Object"].includes(b(t));
};

var E = function E(t) {
  return "Object" === b(t) && Object.keys(t).every(function (t) {
    return !Number.isNaN(parseInt(t, 10));
  });
};

var T = function T(t, e) {
  if (!P(t) || !P(e)) throw new Error("Unsupported data types for deep equals: ".concat(b(t), " & ").concat(b(e)));
  if (b(t) !== b(e)) return !1;
  if (y(t) && y(e)) return t === e;

  var n = function n(t, e) {
    return Object.entries(t).every(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          t = _ref2[0],
          n = _ref2[1];

      return T(e[t], n);
    });
  };

  return t && e && n(t, e) && n(e, t);
};

var C = function C(t) {
  if (y(t)) return t;
  if (O(t)) return t.map(C);

  if (S(t)) {
    var _e = Object.keys(t).reduce(function (e, n) {
      return e[n] = C(t[n]), e;
    }, {});

    var _n = Object.create(Object.getPrototypeOf(t));

    return Object.assign(_n, _e);
  }

  throw new Error("Unsupported data type for clone: " + b(t));
};

var B = function B(t, e) {
  return t.reduce(function (_ref3, s, i) {
    var _ref4 = _slicedToArray(_ref3, 2),
        t = _ref4[0],
        n = _ref4[1];

    return e(s, i) ? [[].concat(_toConsumableArray(t), [s]), n] : [t, [].concat(_toConsumableArray(n), [s])];
  }, [[], []]);
};

var N = function N(t, e) {
  return Object.fromEntries(Object.entries(t).map(function (t) {
    return e(t);
  }));
};

var k = function k(t, e) {
  return N(t, function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        t = _ref6[0],
        n = _ref6[1];

    return [t, e(n)];
  });
};

var U = function U(t, e) {
  return Object.fromEntries(Object.entries(t).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        t = _ref8[1];

    return e(t);
  }));
};

var $ = function $(t, e) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return $(t, e);
  });

  if (S(t)) {
    var _n2 = N(t, function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          t = _ref10[0],
          n = _ref10[1];

      return [t, v.includes(t) ? n : $(n, e)];
    });

    var _s = j(t) ? t._amount : g.MIN_NON_DUST_AMOUNT;

    var _i = x(t) ? t._owners : [e];

    return Object.assign(Object.assign({}, _n2), {
      _amount: _s,
      _owners: _i
    });
  }

  throw new Error("unsupported type ".concat(b(t), " in setOwnersAndAmount"));
};

var K = function K(t, e, n, s) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return K(t, e, n, s);
  });

  if (S(t)) {
    t._rev = "".concat(s, ":").concat(n);
    var _i2 = e[n];
    return Object.entries(t).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          n = _ref12[0],
          r = _ref12[1];

      "object" == typeof _i2 && Object.keys(_i2).includes(n) && (t[n] = K(r, e, _i2[n], s));
    }), t;
  }

  throw new Error("Unsupported type ".concat(b(t), " in deep.updateRev"));
};

var D = function D(t) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return D(t);
  });
  if (S(t)) return t.__cls = t.constructor.toString(), Object.entries(t).forEach(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        e = _ref14[0],
        n = _ref14[1];

    t[e] = D(n);
  }), t;
  throw new Error("Unsupported type ".concat(b(t), " in deep.addClass"));
};

var A = function A(t, e) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return A(t, e);
  });
  if (S(t)) return t._id = !t._id || t._id.startsWith("__temp__") ? t._rev : t._id, t._rootId = t._rootId || e, Object.entries(t).forEach(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        n = _ref16[0],
        s = _ref16[1];

    t[n] = A(s, e);
  }), t;
  throw new Error("Unsupported type ".concat(b(t), " in deep.addId"));
};

var R = function R(t) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return R(t);
  });

  if (S(t)) {
    var _e2 = _();

    return t._id = t._id || _e2, t._rev = t._rev || _e2, Object.values(t).map(function (t) {
      return R(t);
    }), t;
  }

  throw new Error("Unsupported type ".concat(b(t), " in addRandomId"));
};

var H = function H(t) {
  if (y(t)) return t;
  if (O(t)) return t.map(function (t) {
    return H(t);
  });
  if (S(t)) return N(t, function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        t = _ref18[0],
        e = _ref18[1];

    return "_owners" === t ? [t, JSON.stringify(e)] : y(e) ? [t, e] : [t, H(e)];
  });
  throw new Error("Unexpected type ".concat(b(t), " in stringifyOwners"));
};

var M = function M(t) {
  return I(t) ? Object.assign(Object.assign({}, t), {
    _owners: JSON.parse(t._owners).map(function (t) {
      return new w(t);
    })
  }) : t;
};

var L = function L(t) {
  if (y(t)) return t;
  if (O(t) || S(t)) return Object.entries(t).reduce(function (t, _ref19) {
    var _ref20 = _slicedToArray(_ref19, 2),
        e = _ref20[0],
        n = _ref20[1];

    var s = L(n);
    return E(s) ? Object.entries(s).forEach(function (_ref21) {
      var _ref22 = _slicedToArray(_ref21, 2),
          n = _ref22[0],
          s = _ref22[1];

      t["".concat(e, "_").concat(n)] = s;
    }) : t[e] = s, t;
  }, {});
  throw new Error("Unsupported type ".concat(b(t), " in encodeArraysAsObjects"));
};

var z = function z(t) {
  var e = _defineProperty({}, t._id, Object.entries(t).reduce(function (t, _ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
        e = _ref24[0],
        n = _ref24[1];

    return v.includes(e) ? Object.assign(Object.assign({}, t), _defineProperty({}, e, n)) : y(n) ? Object.assign(Object.assign({}, t), _defineProperty({}, "__basic__" + e, n)) : Object.assign(Object.assign({}, t), _defineProperty({}, e, n._id));
  }, {}));

  return Object.values(t).filter(function (t) {
    return !y(t);
  }).reduce(function (t, e) {
    return Object.assign(Object.assign({}, t), z(e));
  }, e);
};

var F = function F(t) {
  return Object.fromEntries(Object.entries(t).filter(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 1),
        t = _ref26[0];

    return !t.startsWith("__basic__");
  }));
};

var V = function V(t, e) {
  return Object.fromEntries(Object.entries(e).map(function (_ref27) {
    var _ref28 = _slicedToArray(_ref27, 2),
        e = _ref28[0],
        n = _ref28[1];

    var s = t[e];
    var i;
    return n.__change = (i = s) ? T(i, n) ? "same" : "diff" : "new", [e, n];
  }));
};

var W = function W(t, e) {
  return t[e].__contains = Object.entries(t[e]).reduce(function (e, _ref29) {
    var _ref30 = _slicedToArray(_ref29, 2),
        n = _ref30[0],
        s = _ref30[1];

    return ["__contains"].concat(v).includes(n) ? e : "__change" === n ? "new" === s || "diff" === s || e : W(t, s)[s].__contains || e;
  }, !1), t;
};

var J = function J(t) {
  return t.reduce(function (t, e, n) {
    return Object.assign(Object.assign({}, t), _defineProperty({}, e._id, n));
  }, {});
};

var q = function q(t, e) {
  return t.map(function (t) {
    return Object.entries(t).reduce(function (t, _ref31) {
      var _ref32 = _slicedToArray(_ref31, 2),
          n = _ref32[0],
          s = _ref32[1];

      var i = "string" == typeof s && "undefined" !== b(e[s]) ? e[s] : s;
      return Object.assign(Object.assign({}, t), _defineProperty({}, n, i));
    }, {});
  });
};

var Z = function Z(t, e, n) {
  var _map = [e].concat(_toConsumableArray(t)).map(function (t, e) {
    var s = r(t, ["_id", "_rev", "__change", "__contains"]);
    return 0 === e || e <= n.length ? r(s, ["__cls"]) : s;
  }),
      _map2 = _toArray(_map),
      s = _map2[0],
      i = _map2.slice(1);

  return [s].concat(_toConsumableArray(i.map(function (t) {
    return Object.fromEntries(Object.entries(t).filter(function (_ref33) {
      var _ref34 = _slicedToArray(_ref33, 2),
          t = _ref34[0],
          e = _ref34[1];

      return v.filter(function (t) {
        return "__cls" !== t;
      }).includes(t) || "__cls" === t && "string" == typeof e && "function Object() { [native code] }" !== e || "number" == typeof e;
    }));
  })));
};

var G = function G(t, e) {
  var n = R(e);
  var s = n._id;
  var i = C(t);
  var r = C(n);
  D(i), D(r);
  var o = H(i);
  var c = H(r);
  var a = L(o);
  var u = L(c);
  var d = z(a);
  var h = z(u);
  var p = V(d, h);
  var l = k(p, F);
  var f = W(l, s);
  var g = f[s];
  delete g.__cls, delete f[s];
  var w = k(f, function (t) {
    return t._rev;
  });

  var _ = U(f, function (t) {
    return t.__contains || Object.values(g).includes(t._id);
  });

  var v = Object.values(_);

  var _B = B(v, function (t) {
    return "new" === t.__change;
  }),
      _B2 = _slicedToArray(_B, 2),
      m = _B2[0],
      b = _B2[1];

  var y = [].concat(_toConsumableArray(b), _toConsumableArray(m));
  var O = J(y);
  var S = q(y, O);

  var _q = q([g], O),
      _q2 = _slicedToArray(_q, 1),
      x = _q2[0];

  var I = b.map(function (t) {
    return t._rev;
  });

  var _Z = Z(S, x, I),
      _Z2 = _toArray(_Z),
      j = _Z2[0],
      P = _Z2.slice(1);

  return [I, P.map(M).map(function (t) {
    return Object.entries(t).reduce(function (t, _ref35) {
      var _ref36 = _slicedToArray(_ref35, 2),
          e = _ref36[0],
          n = _ref36[1];

      return Object.assign(Object.assign({}, t), _defineProperty({}, e, w[n] || n));
    }, {});
  }), j];
};

var Y = function Y(t) {
  return {
    smartArgs: t.filter(function (t) {
      return t._rev;
    }),
    dumbArgs: t.map(function (t) {
      return t._rev ? "__" : t;
    })
  };
};

var Q = function Q(t, e) {
  var n = 0;
  return e.map(function (e) {
    return "__" === e ? t[n++] : e;
  });
};

var X = function X(t) {
  if ("string" != typeof t || 0 === t.length) throw new Error("Please enter a valid id or revision");

  var _t$split = t.split(":"),
      _t$split2 = _slicedToArray(_t$split, 2),
      e = _t$split2[0],
      n = _t$split2[1];

  if (!e || !n) throw new Error("Please enter a valid id or revision of the form <transaction id>:<output number>");
  if (!/^[0-9a-f]{64}$/.test(e)) throw new Error("Invalid Transaction ID");
  if (Number.isNaN(Number(n))) throw new Error("Invalid Number");
};

var tt =
/*#__PURE__*/
function () {
  function tt(t) {
    _classCallCheck(this, tt);

    this.db = t;
  }

  _createClass(tt, [{
    key: "construct",
    value: function construct(t, e) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref37, _ref38, n, s, i, r, o, _ref39, _ref40, c, _c$split, _c$split2, a, u;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tt.getUpdate(e, t, {});

              case 2:
                _ref37 = _context.sent;
                _ref38 = _slicedToArray(_ref37, 6);
                n = _ref38[0];
                s = _ref38[1];
                i = _ref38[2];
                r = _ref38[3];
                o = _ref38[5];
                _context.next = 11;
                return this.db.update(n, s);

              case 11:
                _ref39 = _context.sent;
                _ref40 = _slicedToArray(_ref39, 1);
                c = _ref40[0];
                _c$split = c.split(":"), _c$split2 = _slicedToArray(_c$split, 1), a = _c$split2[0];
                u = "".concat(a, ":").concat(o.obj);
                return _context.abrupt("return", (Object.entries(o).forEach(function (_ref41) {
                  var _ref42 = _slicedToArray(_ref41, 2),
                      t = _ref42[0],
                      e = _ref42[1];

                  K("obj" === t ? i : r[t], s, e, a);
                }), A([i].concat(_toConsumableArray(r)), u), i));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "call",
    value: function call(t, e, n) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref43, _ref44, s, i, r, o, c, _ref45, _ref46, a, _a$split, _a$split2, u, d;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return tt.getUpdate(n, null, t, e);

              case 2:
                _ref43 = _context2.sent;
                _ref44 = _slicedToArray(_ref43, 6);
                s = _ref44[0];
                i = _ref44[1];
                r = _ref44[3];
                o = _ref44[4];
                c = _ref44[5];
                _context2.next = 11;
                return this.db.update(s, i);

              case 11:
                _ref45 = _context2.sent;
                _ref46 = _slicedToArray(_ref45, 1);
                a = _ref46[0];
                _a$split = a.split(":"), _a$split2 = _slicedToArray(_a$split, 1), u = _a$split2[0];
                Object.entries(c).forEach(function (_ref47) {
                  var _ref48 = _slicedToArray(_ref47, 2),
                      e = _ref48[0],
                      n = _ref48[1];

                  "obj" === e && K(t, i, n, u), K("res" === e ? o : r[e], i, n, u);
                });
                d = t._rootId || "".concat(u, ":").concat(c.obj);
                return _context2.abrupt("return", (A([o, t].concat(_toConsumableArray(r)), d), o));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "get",
    value: function get(t, e) {
      var _this = this;

      return "function" == typeof t[e] ? function () {
        for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
          n[_key] = arguments[_key];
        }

        return _this.call(t, e, n);
      } : Reflect.get(t, e);
    }
  }], [{
    key: "getUpdate",
    value: function getUpdate(t, e, n, s) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _C, _C2, i, r, o, c, _Y, a, u, _Y2, d, h, p, _G, _G2, l, f, g, w;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _C = C([t, n]), _C2 = _slicedToArray(_C, 2), i = _C2[0], r = _C2[1];
                o = Object.keys(n).length ? Reflect.apply(n[s], n, t) : null;
                c = Object.keys(n).length ? n : _construct(e, _toConsumableArray(t));
                _Y = Y(i), a = _Y.smartArgs, u = _Y.dumbArgs;
                _Y2 = Y(t), d = _Y2.smartArgs;
                h = Object.assign(Object.assign(Object.assign({}, a), {
                  obj: r
                }), {
                  _id: "index"
                });
                p = Object.assign(Object.assign(Object.assign({}, d), {
                  obj: c
                }), {
                  _id: "index"
                });
                "Object" === b(o) && (p.res = o);
                _G = G(h, p), _G2 = _slicedToArray(_G, 3), l = _G2[0], f = _G2[1], g = _G2[2];
                void 0 !== f[0] && (f[0].__index = g);
                w = g.obj;
                return _context3.abrupt("return", (void 0 !== f[w] && (f[w].__args = u, s ? f[w].__func = s : (f[w].__func = "constructor", f[w].__cls = e.toString())), [l, f, c, d, o, g]));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }]);

  return tt;
}();

var _s$default = s.default,
    et = _s$default.PublicKey,
    nt = _s$default.Script,
    st = _s$default.Opcode;

function it(t, e) {
  var n = [];
  var s = 0;

  for (; s < t.length;) {
    n.push(t.slice(s, s + e)), s += e;
  }

  return n;
}

var rt =
/*#__PURE__*/
function (_nt) {
  _inherits(rt, _nt);

  function rt() {
    _classCallCheck(this, rt);

    return _possibleConstructorReturn(this, _getPrototypeOf(rt).apply(this, arguments));
  }

  _createClass(rt, [{
    key: "getData",
    value: function getData() {
      return this.isDbDataScript() ? JSON.parse(this.chunks[this.chunks.length - 2].buf.toString()) : {};
    }
  }, {
    key: "getPublicKeys",
    value: function getPublicKeys() {
      if (this.isDbDataScript()) return this.chunks.slice(1, this.chunks.length - 4).map(function (t) {
        return new et(t.buf);
      });
      throw new Error("Cannot get owners from non-data script");
    }
  }, {
    key: "isDbDataScript",
    value: function isDbDataScript() {
      return !!(this.chunks.length >= 5 && this.chunks[0].opcodenum === st.OP_1 && this.chunks[1].buf && [20, 33].includes(this.chunks[1].buf.length) && this.chunks[this.chunks.length - 3].opcodenum === st.OP_CHECKMULTISIG && this.chunks[this.chunks.length - 2].buf && this.chunks[this.chunks.length - 1].opcodenum === st.OP_DROP);
    }
  }], [{
    key: "outScriptFromData",
    value: function outScriptFromData(t) {
      var e = t._owners,
          n = t._amount,
          s = t.__vouts,
          i = t.__txId,
          o = r(t, ["_owners", "_amount", "__vouts", "__txId"]);
      var c = it(Buffer.from(JSON.stringify(o)), g.SCRIPT_CHUNK_SIZE);
      return c[c.length - 1].byteLength >= g.SCRIPT_CHUNK_SIZE && it(c.pop(), g.SCRIPT_CHUNK_SIZE).forEach(function (t) {
        c.push(t);
      }), c.map(function (t) {
        return {
          redeemScript: rt.getScript(t, e),
          chunk: t
        };
      });
    }
  }, {
    key: "getScript",
    value: function getScript(t, e) {
      var n = new rt();
      return n.add("OP_1"), e.forEach(function (t) {
        return n.add(t.toBuffer());
      }), n.add("OP_" + e.length), n.add("OP_CHECKMULTISIG"), n.add(t), n.add("OP_DROP"), n;
    }
  }, {
    key: "isP2shScript",
    value: function isP2shScript(t) {
      return !(3 !== t.chunks.length || t.chunks[0].opcodenum !== st.OP_0 || !t.chunks[1].buf || !t.chunks[2].buf);
    }
  }, {
    key: "redeemScriptFromP2shScript",
    value: function redeemScriptFromP2shScript(t) {
      if (!this.isP2shScript(t)) throw new Error("not a p2sh script");
      var e = new nt(t.chunks[2].buf);
      var n = new this();
      return n.chunks = e.chunks, n;
    }
  }, {
    key: "fromScript",
    value: function fromScript(t) {
      var e = new nt(t);
      var n = new rt();
      return n.chunks = e.chunks, n;
    }
  }]);

  return rt;
}(nt);

var _s$default2 = s.default,
    ot = _s$default2.Address,
    ct = _s$default2.Transaction,
    at = _s$default2.PublicKey;
var ut = new Map();

var dt =
/*#__PURE__*/
function () {
  function dt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : g.CHAIN;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : g.NETWORK;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : g.WOC_API_KEY;

    _classCallCheck(this, dt);

    this.chain = t, this.network = e, "BSV" === t && (this.wocApiKey = n);
  }

  _createClass(dt, [{
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return "BSV" === this.chain ? "https://api.whatsonchain.com/v1/bsv/" + ("livenet" === this.network ? "main" : "test") : "https://".concat("livenet" === this.network ? "rest" : "trest", ".bitcoin.com/v2");
    }
  }, {
    key: "getRequestHeaders",
    value: function getRequestHeaders() {
      return "BSV" === this.chain && this.wocApiKey ? {
        "woc-api-key": this.wocApiKey
      } : {};
    }
  }, {
    key: "unwrap",
    value: function unwrap(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _e4, _n3, _s2, _i3, _r, _o, _c, _a;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return t;

              case 3:
                return _context4.abrupt("return", _context4.sent.data);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                _e4 = _context4.t0.message, _n3 = _context4.t0.config, _s2 = _context4.t0.response;
                _i3 = _n3.url, _r = _n3.method, _o = _n3.data;

                try {
                  _c = JSON.parse(_o);
                } catch (t) {
                  _c = null;
                }

                _a = _c && _c.txhex ? new ct(_c.txhex) : null;
                throw _context4.t0.message = "\n        Communication Error\n        message\t".concat(_e4, "\n        request\t").concat(_r, " ").concat(_i3, "\n        ").concat(_a ? "transaction\t " + JSON.stringify(_a.toJSON(), null, 2) : "post" !== _r || _a ? "" : "data\t" + _o, "\n        ").concat(_s2 ? "response\t" + JSON.stringify(_s2.data) : ""), _context4.t0;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }));
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var n;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                n = e ? "" : this.getBaseUrl();
                return _context5.abrupt("return", this.unwrap(i.default.get("".concat(n).concat(t), {
                  headers: this.getRequestHeaders()
                })));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "post",
    value: function post(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var s;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                s = n ? "" : this.getBaseUrl();
                return _context6.abrupt("return", this.unwrap(i.default.post("".concat(s).concat(t), e, {
                  headers: this.getRequestHeaders()
                })));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getBalance",
    value: function getBalance(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var e, n, s;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                e = "/address/".concat(t.toString(), "/balance");
                n = "/address/details/" + t.toString();
                _context7.t0 = this.chain;
                _context7.next = _context7.t0 === "BSV" ? 5 : _context7.t0 === "BCH" ? 9 : 13;
                break;

              case 5:
                _context7.next = 7;
                return this.get(e);

              case 7:
                s = _context7.sent;
                return _context7.abrupt("return", parseInt(s.confirmed, 10) + parseInt(s.unconfirmed, 10));

              case 9:
                _context7.next = 11;
                return this.get(n);

              case 11:
                s = _context7.sent;
                return _context7.abrupt("return", parseInt(s.balanceSat, 10) + parseInt(s.unconfirmedBalanceSat, 10));

              case 13:
                throw new Error("chain is not set in getBalance");

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getTransaction",
    value: function getTransaction(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var e;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getRawTransaction(t);

              case 2:
                e = _context8.sent;
                return _context8.abrupt("return", new ct(e));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "getTransactionWithSpendingData",
    value: function getTransactionWithSpendingData(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _t$split3, _t$split4, e, _t2, _ref49, _n4, _n4$e, s, _i4, _r2;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!("testnet" === this.network && "BSV" === this.chain)) {
                  _context9.next = 2;
                  break;
                }

                throw new Error("Restclient.getTransactionWithSpendingData is not supported on BSV testnet");

              case 2:
                _t$split3 = t.split(":"), _t$split4 = _slicedToArray(_t$split3, 1), e = _t$split4[0];
                _context9.t0 = this.chain;
                _context9.next = _context9.t0 === "BSV" ? 6 : _context9.t0 === "BCH" ? 13 : 14;
                break;

              case 6:
                _t2 = "https://api.blockchair.com/bitcoin-sv/dashboards/transaction/" + e;
                _context9.next = 9;
                return this.get(_t2, !0);

              case 9:
                _ref49 = _context9.sent;
                _n4 = _ref49.data;
                _n4$e = _n4[e], s = _n4$e.transaction, _i4 = _n4$e.inputs, _r2 = _n4$e.outputs;
                return _context9.abrupt("return", {
                  hex: "",
                  txid: s.hash,
                  hash: s.hash,
                  version: s.version,
                  size: s.size,
                  locktime: s.lock_time,
                  vin: _i4,
                  vout: _r2.map(function (t) {
                    return {
                      value: t.value,
                      n: t.index,
                      scriptPubKey: t.script_hex,
                      spentTxId: t.spending_transaction_id,
                      spentIndex: t.spending_index
                    };
                  }),
                  blockhash: "unknown",
                  confirmations: "unknown",
                  time: "unknown",
                  blocktime: "unknown"
                });

              case 13:
                return _context9.abrupt("return", this.get("/transaction/details/" + e));

              case 14:
                throw new Error("chain is not set in getTransactionWithSpendingData");

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "getRawTransaction",
    value: function getRawTransaction(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _t$split5, _t$split6, e, n, s, r;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _t$split5 = t.split(":"), _t$split6 = _slicedToArray(_t$split5, 1), e = _t$split6[0];
                n = ut.get(e);

                if (!n) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return", n);

              case 4:
                s = "livenet" === this.network ? "main" : "test";
                _context10.next = 7;
                return this.unwrap(i.default.get("".concat(g.UN_P2SH_URL, "/tx/").concat(this.chain, "/").concat(s, "/").concat(e)));

              case 7:
                r = _context10.sent;
                return _context10.abrupt("return", (ut.set(e, r), r));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var n, _e5, s, _i5;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!("BSV" === this.chain)) {
                  _context11.next = 6;
                  break;
                }

                _context11.next = 3;
                return this.post("/tx/raw", {
                  txhex: t.toString()
                });

              case 3:
                n = _context11.sent;
                _context11.next = 11;
                break;

              case 6:
                if (!("BCH" !== this.chain)) {
                  _context11.next = 8;
                  break;
                }

                throw new Error("chain is not set in sendTransaction");

              case 8:
                _context11.next = 10;
                return this.post("/rawtransactions/sendRawTransaction", {
                  hexes: [t.toString()]
                })[0];

              case 10:
                n = _context11.sent;

              case 11:
                if (!e) {
                  _context11.next = 17;
                  break;
                }

                _e5 = t.outputData.map(function (t) {
                  var e = t._owners;

                  if (void 0 !== e) {
                    var _n5 = e.map(function (t) {
                      return t.toString();
                    });

                    return Object.assign(Object.assign({}, t), {
                      _owners: _n5
                    });
                  }

                  return t;
                });
                s = JSON.stringify(_e5);
                _i5 = t.toJSON().inputs.map(function (_ref50) {
                  var t = _ref50.prevTxId,
                      e = _ref50.outputIndex;
                  return "".concat(t, ":").concat(e);
                });
                _context11.next = 17;
                return this.postOutputData({
                  txId: n,
                  outputData: s,
                  inputs: _i5
                });

              case 17:
                return _context11.abrupt("return", n);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getUtxosFromAddress",
    value: function getUtxosFromAddress(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var _this2 = this,
            _ref52;

        var e, n;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                e = [];
                n = "";
                _context13.t0 = this.chain;
                _context13.next = _context13.t0 === "BSV" ? 5 : _context13.t0 === "BCH" ? 9 : 16;
                break;

              case 5:
                _context13.next = 7;
                return this.get("/address/".concat(t.toString(), "/unspent"));

              case 7:
                e = _context13.sent;
                return _context13.abrupt("return", Promise.all(e.map(function (_ref51) {
                  var t = _ref51.tx_hash,
                      e = _ref51.tx_pos,
                      n = _ref51.value;
                  return {
                    txId: t,
                    vout: e,
                    satoshis: n,
                    amount: n / 1e8
                  };
                }).map(function (t) {
                  return o(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee12() {
                    var e;
                    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return this.getTransaction(t.txId);

                          case 2:
                            _context12.t0 = t.vout;
                            e = _context12.sent.outputs[_context12.t0];
                            return _context12.abrupt("return", Object.assign(Object.assign({}, t), {
                              scriptPubKey: e.script.toHex()
                            }));

                          case 5:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  }));
                })));

              case 9:
                _context13.next = 11;
                return this.get("/address/utxo/" + t.toString());

              case 11:
                _ref52 = _context13.sent;
                e = _ref52.utxos;
                n = _ref52.scriptPubKey;
                _ref52;
                return _context13.abrupt("return", e.map(function (t) {
                  return Object.assign({
                    scriptPubKey: n
                  }, t);
                }).map(function (t) {
                  var e = t.txid,
                      n = r(t, ["txid"]);
                  return Object.assign({
                    txId: e
                  }, n);
                }));

              case 16:
                throw new Error("chain is not set in getUtxosFromAddress");

              case 17:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getTxosFromOutputData",
    value: function getTxosFromOutputData(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _this3 = this;

        var e, n, s;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                e = t.map(function (t) {
                  return t.__txId;
                });
                n = _toConsumableArray(new Set(e));
                s = new Map();
                _context15.next = 5;
                return Promise.all(n.map(function (t) {
                  return o(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee14() {
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            _context14.t0 = s;
                            _context14.t1 = t;
                            _context14.next = 4;
                            return this.getTransaction(t);

                          case 4:
                            _context14.t2 = _context14.sent;
                            return _context14.abrupt("return", _context14.t0.set.call(_context14.t0, _context14.t1, _context14.t2));

                          case 6:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14, this);
                  }));
                }));

              case 5:
                return _context15.abrupt("return", t.map(function (t) {
                  var _ref53 = s.get(t.__txId) || {},
                      e = _ref53.outputs,
                      n = _ref53.blockheight,
                      i = _ref53.confirmations;

                  return t.__vouts.map(function (s) {
                    var _e$s = e[s],
                        r = _e$s._scriptBuffer,
                        o = _e$s._satoshis;
                    return {
                      txId: t.__txId,
                      vout: s,
                      scriptPubKey: r.toString("hex"),
                      amount: o / 1e8,
                      satoshis: parseInt(o, 10),
                      height: n,
                      confirmations: i
                    };
                  });
                }));

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));
    }
  }, {
    key: "postOutputData",
    value: function postOutputData(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.post(g.UN_P2SH_URL + "/", t, !0));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getOutputData",
    value: function getOutputData(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.get("".concat(g.UN_P2SH_URL, "/un-p2sh/").concat(t), !0);

              case 2:
                _context17.t0 = _context17.sent;

                if (_context17.t0) {
                  _context17.next = 5;
                  break;
                }

                _context17.t0 = [];

              case 5:
                _context17.t1 = function (t) {
                  return t._owners ? Object.assign(Object.assign({}, t), {
                    _owners: t._owners.map(function (t) {
                      return new at(t);
                    })
                  }) : t;
                };

                return _context17.abrupt("return", _context17.t0.map(_context17.t1));

              case 7:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "getOwnedRevs",
    value: function getOwnedRevs(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.get("".concat(g.UN_P2SH_URL, "/txos/").concat(t.toString()), !0));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "getLatestRev",
    value: function getLatestRev(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var _ref54, _ref55, e;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.get("".concat(g.UN_P2SH_URL, "/get-rev/").concat(t), !0);

              case 2:
                _ref54 = _context19.sent;
                _ref55 = _slicedToArray(_ref54, 1);
                e = _ref55[0].rev;
                return _context19.abrupt("return", e);

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "setTxoSpent",
    value: function setTxoSpent(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var _t$split7, _t$split8, e, n;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _t$split7 = t.split(":"), _t$split8 = _slicedToArray(_t$split7, 2), e = _t$split8[0], n = _t$split8[1];
                return _context20.abrupt("return", this.post(g.UN_P2SH_URL + "/txos/set-spent/", {
                  txId: e,
                  virtualIndex: parseInt(n, 10)
                }, !0));

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
  }]);

  return dt;
}();

function ht(t) {
  return {
    writable: !0,
    value: t
  };
}

function pt(t, e, n) {
  var s = t,
      i = n[s],
      o = r(n, ["symbol" == typeof s ? s : s + ""]);
  return Object.assign(_defineProperty({}, e, i), o);
}

var _s$default3 = s.default,
    lt = _s$default3.Transaction,
    ft = _s$default3.PublicKey,
    gt = _s$default3.Address,
    wt = _s$default3.encoding;
var _t = lt.Output,
    vt = lt.Input;
var mt = vt.MultiSigScriptHash;
var bt = wt.BufferReader;

var yt = function yt(t) {
  return new Promise(function (e) {
    return setTimeout(e, t);
  });
};

var Ot =
/*#__PURE__*/
function (_lt) {
  _inherits(Ot, _lt);

  function Ot(t, e, n) {
    var _this4;

    _classCallCheck(this, Ot);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Ot).call(this, n)), _this4._outputData = [], _this4.restClient = new dt(t, e), _this4.feePerKb(g.DEFAULT_FEE), Object.defineProperty(_assertThisInitialized(_this4), "from", ht(_this4._from));
    return _this4;
  }

  _createClass(Ot, [{
    key: "getVirtualInputs",
    value: function getVirtualInputs() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var _this5 = this;

        var _t3, _e6;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!("BSV" === this.chain)) {
                  _context23.next = 6;
                  break;
                }

                _context23.next = 3;
                return Promise.all(this.inputs.map(function (t) {
                  return o(_this5, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee21() {
                    var e, n, s;
                    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                      while (1) {
                        switch (_context21.prev = _context21.next) {
                          case 0:
                            e = t.outputIndex;
                            n = t.prevTxId.toString("hex");
                            _context21.next = 4;
                            return Ot.fromTxId(n, this.chain, this.network);

                          case 4:
                            _context21.t0 = e;
                            s = _context21.sent.outputs[_context21.t0];
                            return _context21.abrupt("return", !!rt.fromScript(s._scriptBuffer).isDbDataScript() && t);

                          case 7:
                          case "end":
                            return _context21.stop();
                        }
                      }
                    }, _callee21, this);
                  }));
                }));

              case 3:
                _context23.t0 = function (t) {
                  return !!t;
                };

                _context23.t1 = function (t) {
                  return "".concat(t.prevTxId.toString("hex"), ":").concat(t.outputIndex);
                };

                return _context23.abrupt("return", _context23.sent.filter(_context23.t0).map(_context23.t1));

              case 6:
                if (!("BCH" === this.chain)) {
                  _context23.next = 10;
                  break;
                }

                _t3 = this.dataInputs;
                _e6 = Ot.addVouts(_t3);
                return _context23.abrupt("return", Promise.all(_e6.map(function (t) {
                  return o(_this5, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee22() {
                    var _this6 = this;

                    var e, n, s, i, r;
                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            e = [];

                            t.__vouts.forEach(function (t) {
                              e.push(_this6.inputs[t]);
                            });

                            n = e[0].prevTxId.toString("hex");
                            _context22.next = 5;
                            return Ot.fromTxId(n, this.chain, this.network);

                          case 5:
                            s = _context22.sent;
                            _context22.next = 8;
                            return s.fetchOutputData();

                          case 8:
                            i = Ot.addVouts(s.outputData);
                            r = [];
                            return _context22.abrupt("return", (i.forEach(function (t, n) {
                              T(t.__vouts, e.map(function (t) {
                                return t.outputIndex;
                              })) && r.push(n);
                            }), "".concat(n, ":").concat(r[0])));

                          case 11:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22, this);
                  }));
                })));

              case 10:
                throw new Error("chain not set in getVirtualInputs");

              case 11:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "fromMultiSig",
    value: function fromMultiSig(t, e, n) {
      var s = t.map(function (t) {
        return pt("txId", "txid", t);
      });
      return _get(_getPrototypeOf(Ot.prototype), "from", this).call(this, s, e, n);
    }
  }, {
    key: "_from",
    value: function _from(t, e, n) {
      var s = pt("txId", "txid", t);
      return _get(_getPrototypeOf(Ot.prototype), "from", this).call(this, s, e, n);
    }
  }, {
    key: "fromDataOutput",
    value: function fromDataOutput(t, e) {
      var _this7 = this;

      var n = rt.outScriptFromData(e);
      var s = e._owners;
      return n.forEach(function (_ref56, n) {
        var e = _ref56.redeemScript;
        var _t$n = t[n],
            i = _t$n.scriptPubKey,
            r = _t$n.satoshis,
            o = _t$n.txId,
            c = _t$n.vout;
        var a = new _t({
          script: new rt(i),
          satoshis: r
        });
        var u = new rt();
        var d = new mt({
          prevTxId: o,
          output: a,
          outputIndex: c,
          script: u
        }, s, 1, null, e);

        _this7.addInput(d);
      }), this;
    }
  }, {
    key: "toData",
    value: function toData(t) {
      var _this8 = this;

      if ("BSV" === this.chain) {
        var _e7 = t._owners,
            n = t._amount,
            s = r(t, ["_owners", "_amount"]);

        var _i6 = Buffer.from(JSON.stringify(s));

        var _o2 = rt.getScript(_i6, _e7);

        var _c2 = new _t({
          script: _o2,
          satoshis: n
        });

        return this.addOutput(_c2), this.outputs.length - 1;
      }

      if ("BCH" === this.chain) {
        var _e8 = rt.outScriptFromData(t);

        return this._outputData.push(t), _e8.forEach(function (_ref57) {
          var e = _ref57.redeemScript;
          var n = rt.buildScriptHashOut(e);
          var s = t._amount;
          var i = new _t({
            script: n,
            satoshis: s
          });

          _this8.addOutput(i);
        }), this._outputData.length - 1;
      }

      throw new Error("chain not set in dataScript.toScriptOutput");
    }
  }, {
    key: "fetchOutputData",
    value: function fetchOutputData() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        var t;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!this._outputData.length) {
                  _context24.next = 2;
                  break;
                }

                return _context24.abrupt("return");

              case 2:
                t = this.getTxId();

                if (!("BSV" === this.chain)) {
                  _context24.next = 7;
                  break;
                }

                this._outputData = this.outputs.map(function (t) {
                  var e = rt.fromScript(t._scriptBuffer);
                  var n = t._satoshis;

                  if (e.isDbDataScript()) {
                    var _t4 = e.getPublicKeys().map(function (t) {
                      return t.toString();
                    });

                    return Object.assign(e.getData(), {
                      _amount: n,
                      _owners: _t4
                    });
                  }

                  if (e.isPublicKeyHashOut()) {
                    var _t5 = e.getPublicKeyHash();

                    return {
                      address: gt.fromPublicKeyHash(_t5)
                    };
                  }

                  throw new Error("Unrecognized output script " + e.toString());
                });
                _context24.next = 12;
                break;

              case 7:
                _context24.t0 = "BCH" === this.chain;

                if (!_context24.t0) {
                  _context24.next = 12;
                  break;
                }

                _context24.next = 11;
                return this.restClient.getOutputData(t);

              case 11:
                this._outputData = _context24.sent;

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "getTxId",
    value: function getTxId() {
      return new bt(this._getHash()).readReverse().toString("hex");
    }
  }, {
    key: "getChangeIndex",
    value: function getChangeIndex() {
      return this._changeIndex;
    }
  }, {
    key: "chain",
    get: function get() {
      return this.restClient.chain;
    }
  }, {
    key: "network",
    get: function get() {
      return this.restClient.network;
    }
  }, {
    key: "dataInputs",
    get: function get() {
      var t = [];

      var e =
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25(t) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _e9;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context25.prev = 3;
                _iterator = t[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context25.next = 12;
                  break;
                }

                _e9 = _step.value;
                _context25.next = 9;
                return _e9;

              case 9:
                _iteratorNormalCompletion = true;
                _context25.next = 5;
                break;

              case 12:
                _context25.next = 18;
                break;

              case 14:
                _context25.prev = 14;
                _context25.t0 = _context25["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context25.t0;

              case 18:
                _context25.prev = 18;
                _context25.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 21:
                _context25.prev = 21;

                if (!_didIteratorError) {
                  _context25.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context25.finish(21);

              case 25:
                return _context25.finish(18);

              case 26:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[3, 14, 18, 26], [19,, 21, 25]]);
      })(this.inputs);

      var n = e.next();

      for (; !n.done;) {
        var s = n.value;

        var _i7 = rt.fromScript(s._scriptBuffer);

        if (rt.isP2shScript(_i7)) {
          var _n6 = !1;

          var _s3 = [rt.redeemScriptFromP2shScript(_i7)];

          for (; !_n6;) {
            try {
              t.push(Ot.fromRedeemScripts(_s3)), _n6 = !0;
            } catch (t) {
              var _n7 = e.next();

              if (_n7.done) throw new Error("Could not compute data inputs");
              var _i8 = _n7.value;

              var _r3 = rt.fromScript(_i8._scriptBuffer);

              _s3.push(rt.redeemScriptFromP2shScript(_r3));
            }
          }
        }

        n = e.next();
      }

      return t;
    },
    set: function set(t) {
      throw Error("dataTransaction.dataInputs cannot be set directly, use dataTransaction.from or dataTransaction.fromDataOutput");
    }
  }, {
    key: "outputData",
    get: function get() {
      if ("BSV" === this.chain) return this.outputs.filter(function (t) {
        return rt.fromScript(t._scriptBuffer).isDbDataScript();
      }).map(function (t) {
        var _ref58 = t._script || t.script,
            e = _ref58.chunks;

        var n = e[e.length - 2].buf;
        var s = JSON.parse(n.toString());
        var i = e.slice(1, e.length - 4);
        return s._owners = i.map(function (t) {
          return new ft(t.buf).toString();
        }), s._amount = t._satoshis, s;
      });
      if ("BCH" === this.chain) return this._outputData;
      throw new Error("Chain not set in dataTransaction get outputdata");
    },
    set: function set(t) {
      throw Error("dataTransaction.outputData cannot be set directly");
    }
  }, {
    key: "prevObjectIds",
    get: function get() {
      return this.inputs.map(function (t) {
        return "".concat(t.prevTxId.toString("hex"), ":").concat(t.outputIndex);
      });
    }
  }], [{
    key: "fromRedeemScripts",
    value: function fromRedeemScripts(t) {
      var e = t.map(function (t) {
        return t.chunks[t.chunks.length - 2].buf;
      });
      var n = Buffer.concat(e);
      var s = JSON.parse(n.toString());
      return Object.assign({
        _owners: t[0].getPublicKeys(),
        _amount: g.MIN_NON_DUST_AMOUNT
      }, s);
    }
  }, {
    key: "addVouts",
    value: function addVouts(t) {
      var e = 0;
      return t.map(function (t) {
        var n = rt.outScriptFromData(t).length;
        var s = Object.assign(Object.assign({}, t), {
          __vouts: []
        });
        return s.__vouts = Array(n).fill(e).map(function (t, e) {
          return t + e;
        }), e += n, s;
      });
    }
  }, {
    key: "fromTxId",
    value: function fromTxId(t, e, n) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        var s, i, r;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                s = null;
                i = new dt(e, n);
                _context26.prev = 2;
                _context26.next = 5;
                return i.getRawTransaction(t);

              case 5:
                s = _context26.sent;
                _context26.next = 15;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](2);
                _context26.next = 12;
                return yt(3e3);

              case 12:
                _context26.next = 14;
                return i.getRawTransaction(t);

              case 14:
                s = _context26.sent;

              case 15:
                r = new Ot(e, n);
                return _context26.abrupt("return", (r.fromString(s), r));

              case 17:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[2, 8]]);
      }));
    }
  }]);

  return Ot;
}(lt);

var St = s.default.PublicKey;

var xt =
/*#__PURE__*/
function () {
  function xt(t) {
    _classCallCheck(this, xt);

    this.wallet = t;
  }

  _createClass(xt, [{
    key: "put",
    value: function put(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.update([], t));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "getOutputDataMap",
    value: function getOutputDataMap(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        var _this9 = this;

        var e, n;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                e = _toConsumableArray(new Set(t));
                _context29.next = 3;
                return Promise.all(e.map(function (t) {
                  return o(_this9, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee28() {
                    var e, n, s;
                    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                      while (1) {
                        switch (_context28.prev = _context28.next) {
                          case 0:
                            _context28.next = 2;
                            return this.wallet.restClient.getOutputData(t);

                          case 2:
                            e = _context28.sent;
                            n = 0;
                            s = e.map(function (e) {
                              var s = Object.assign({}, e);
                              var i = rt.outScriptFromData(s).length;
                              var r = Array(i).fill(n).map(function (t, e) {
                                return t + e;
                              });
                              return n += i, void 0 !== s._owners && (s._owners = s._owners.map(function (t) {
                                return new St(t);
                              })), Object.assign(Object.assign({}, s), {
                                __vouts: r,
                                __txId: t
                              });
                            });
                            return _context28.abrupt("return", [t, s]);

                          case 6:
                          case "end":
                            return _context28.stop();
                        }
                      }
                    }, _callee28, this);
                  }));
                }));

              case 3:
                n = _context29.sent;
                return _context29.abrupt("return", new Map(n));

              case 5:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));
    }
  }, {
    key: "get",
    value: function get(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var _this10 = this;

        var _e10, n, s, _i9, _e11, _n8;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (!("BSV" === this.chain)) {
                  _context32.next = 8;
                  break;
                }

                _e10 = t.map(function (t) {
                  return t.split(":")[0];
                });
                n = _toConsumableArray(new Set(_e10));
                _context32.next = 5;
                return Promise.all(n.map(function (t) {
                  return o(_this10, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee30() {
                    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
                      while (1) {
                        switch (_context30.prev = _context30.next) {
                          case 0:
                            _context30.t0 = t;
                            _context30.next = 3;
                            return this.wallet.restClient.getTransaction(t);

                          case 3:
                            _context30.t1 = _context30.sent;
                            return _context30.abrupt("return", [_context30.t0, _context30.t1]);

                          case 5:
                          case "end":
                            return _context30.stop();
                        }
                      }
                    }, _callee30, this);
                  }));
                }));

              case 5:
                s = _context32.sent;
                _i9 = new Map(s);
                return _context32.abrupt("return", Promise.all(t.map(function (t) {
                  return o(_this10, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee31() {
                    var _t$split9, _t$split10, e, n, s, r;

                    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                      while (1) {
                        switch (_context31.prev = _context31.next) {
                          case 0:
                            _t$split9 = t.split(":"), _t$split10 = _slicedToArray(_t$split9, 2), e = _t$split10[0], n = _t$split10[1];
                            s = _i9.get(e).outputs[parseInt(n, 10)];
                            r = rt.fromScript(s.script);
                            return _context31.abrupt("return", Object.assign(r.getData(), {
                              __txId: e,
                              __vouts: [parseInt(n, 10)],
                              _owners: r.getPublicKeys(),
                              _amount: Math.round(s.satoshis)
                            }));

                          case 4:
                          case "end":
                            return _context31.stop();
                        }
                      }
                    }, _callee31);
                  }));
                })));

              case 8:
                if (!("BCH" === this.chain)) {
                  _context32.next = 14;
                  break;
                }

                _e11 = t.map(function (t) {
                  return t.split(":")[0];
                });
                _context32.next = 12;
                return this.getOutputDataMap(_e11);

              case 12:
                _n8 = _context32.sent;
                return _context32.abrupt("return", t.map(function (t) {
                  var _t$split11 = t.split(":"),
                      _t$split12 = _slicedToArray(_t$split11, 2),
                      e = _t$split12[0],
                      s = _t$split12[1];

                  var i = _n8.get(e);

                  if (!i || !Array.isArray(i)) throw new Error("No data found.");
                  return i[parseInt(s, 10)];
                }));

              case 14:
                throw new Error("chain not set in db.get");

              case 15:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
  }, {
    key: "getUpdateTxBch",
    value: function getUpdateTxBch(t, e) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        var _this11 = this;

        var n, s, i, r;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                n = new Ot(this.chain, this.network);
                _context34.next = 3;
                return this.get(t);

              case 3:
                s = _context34.sent;
                _context34.next = 6;
                return this.wallet.restClient.getTxosFromOutputData(s);

              case 6:
                i = _context34.sent;
                t.forEach(function (t, e) {
                  return o(_this11, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee33() {
                    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            n.fromDataOutput(i[e], s[e]);

                          case 1:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33);
                  }));
                });
                r = $(e, this.wallet.getPublicKey()).map(function (t) {
                  return n.toData(t);
                });
                _context34.next = 11;
                return this.wallet.fundAndSendTransaction(n, !0);

              case 11:
                _context34.t0 = _context34.sent;
                _context34.t1 = r;
                return _context34.abrupt("return", {
                  txId: _context34.t0,
                  virtualIndices: _context34.t1
                });

              case 14:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "getUpdateTxBsv",
    value: function getUpdateTxBsv(t, e) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        var _this12 = this;

        var n, s;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                n = new Ot(this.chain, this.network);
                _context36.next = 3;
                return Promise.all(t.map(function (t) {
                  return o(_this12, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee35() {
                    var _t$split13, _t$split14, e, n, s, _s$outputs$parseInt, i, r, o;

                    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                      while (1) {
                        switch (_context35.prev = _context35.next) {
                          case 0:
                            _t$split13 = t.split(":"), _t$split14 = _slicedToArray(_t$split13, 2), e = _t$split14[0], n = _t$split14[1];
                            _context35.next = 3;
                            return this.wallet.restClient.getTransaction(e);

                          case 3:
                            s = _context35.sent;
                            _s$outputs$parseInt = s.outputs[parseInt(n, 10)], i = _s$outputs$parseInt.script, r = _s$outputs$parseInt.satoshis;
                            o = rt.fromScript(i);
                            return _context35.abrupt("return", {
                              output: {
                                txId: e,
                                outputIndex: parseInt(n, 10),
                                scriptPubKey: o,
                                satoshis: Math.round(r)
                              },
                              publicKeys: o.getPublicKeys(),
                              nr: 1
                            });

                          case 7:
                          case "end":
                            return _context35.stop();
                        }
                      }
                    }, _callee35, this);
                  }));
                }));

              case 3:
                _context36.t0 = function (_ref59) {
                  var t = _ref59.output,
                      e = _ref59.publicKeys,
                      s = _ref59.nr;
                  n.from(t, e, s);
                };

                _context36.sent.forEach(_context36.t0);

                s = $(e, this.wallet.getPublicKey()).map(function (t) {
                  return n.toData(t);
                });
                _context36.next = 8;
                return this.wallet.fundAndSendTransaction(n, !0);

              case 8:
                _context36.t1 = _context36.sent;
                _context36.t2 = s;
                return _context36.abrupt("return", {
                  txId: _context36.t1,
                  virtualIndices: _context36.t2
                });

              case 11:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "update",
    value: function update(t, e) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        var _this13 = this;

        var _ref60, n, s, _ref61, _n9, _s4;

        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (!("BSV" === this.chain)) {
                  _context39.next = 9;
                  break;
                }

                _context39.next = 3;
                return this.getUpdateTxBsv(t, e);

              case 3:
                _ref60 = _context39.sent;
                n = _ref60.txId;
                s = _ref60.virtualIndices;
                _context39.next = 8;
                return Promise.all(t.map(function (t) {
                  return o(_this13, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee37() {
                    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                      while (1) {
                        switch (_context37.prev = _context37.next) {
                          case 0:
                            _context37.next = 2;
                            return this.wallet.restClient.setTxoSpent(t);

                          case 2:
                          case "end":
                            return _context37.stop();
                        }
                      }
                    }, _callee37, this);
                  }));
                }));

              case 8:
                return _context39.abrupt("return", s.map(function (t) {
                  return "".concat(n, ":").concat(t);
                }));

              case 9:
                if (!("BCH" === this.chain)) {
                  _context39.next = 16;
                  break;
                }

                _context39.next = 12;
                return this.getUpdateTxBch(t, e);

              case 12:
                _ref61 = _context39.sent;
                _n9 = _ref61.txId;
                _s4 = _ref61.virtualIndices;
                return _context39.abrupt("return", (t.forEach(function (t) {
                  return o(_this13, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee38() {
                    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
                      while (1) {
                        switch (_context38.prev = _context38.next) {
                          case 0:
                            _context38.next = 2;
                            return this.wallet.restClient.setTxoSpent(t);

                          case 2:
                          case "end":
                            return _context38.stop();
                        }
                      }
                    }, _callee38, this);
                  }));
                }), _s4.map(function (t) {
                  return "".concat(_n9, ":").concat(t);
                })));

              case 16:
                throw new Error("Chain not set in db.update " + this.chain);

              case 17:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "chain",
    get: function get() {
      return this.wallet.chain;
    }
  }, {
    key: "network",
    get: function get() {
      return this.wallet.network;
    }
  }]);

  return xt;
}();

var _s$default4 = s.default,
    It = _s$default4.Mnemonic,
    jt = _s$default4.HDPrivateKey,
    Pt = _s$default4.Address,
    Et = _s$default4.PublicKey,
    Tt = _s$default4.PrivateKey;

var Ct =
/*#__PURE__*/
function () {
  function Ct(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Ct);

    var _n$path = n.path,
        s = _n$path === void 0 ? "m/44'/0'/0'/0" : _n$path,
        _n$passphrase = n.passphrase,
        i = _n$passphrase === void 0 ? "" : _n$passphrase;
    this.mnemonic = t, this.path = s, this.passphrase = i, this.restClient = e, this.utoxsSyncing = !1, this.hdPrivateKey = this.mnemonic.toHDPrivateKey(this.passphrase, g.NETWORK), this.path && (this.hdPrivateKey = this.hdPrivateKey.derive(this.path)), this.utxos = [], this.syncUtxos();
  }

  _createClass(Ct, [{
    key: "getMnemonic",
    value: function getMnemonic() {
      return this.mnemonic;
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return this.path;
    }
  }, {
    key: "getUtxos",
    value: function getUtxos() {
      return this.utxos;
    }
  }, {
    key: "derive",
    value: function derive() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = new Ct(this.mnemonic, this.restClient);
      return n.path = "".concat(this.path).concat(this.path.length ? "/" : "").concat(t).concat(e ? "'" : ""), n.hdPrivateKey = this.hdPrivateKey.derive(t, e), n;
    }
  }, {
    key: "getPrivateKey",
    value: function getPrivateKey() {
      return this.hdPrivateKey.privateKey;
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey() {
      return this.hdPrivateKey.publicKey;
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      return this.address = this.address || this.getPublicKey().toAddress(this.network), this.address;
    }
  }, {
    key: "syncUtxos",
    value: function syncUtxos() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                this.utoxsSyncing = !0;
                _context40.next = 3;
                return this.restClient.getUtxosFromAddress(this.getAddress());

              case 3:
                this.utxos = _context40.sent;
                this.utoxsSyncing = !1;

              case 5:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "waitUntilSynced",
    value: function waitUntilSynced() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (!this.utoxsSyncing) {
                  _context41.next = 5;
                  break;
                }

                _context41.next = 3;
                return new Promise(function (t) {
                  return setTimeout(t, 300);
                });

              case 3:
                _context41.next = 0;
                break;

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "getBalance",
    value: function getBalance() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        var t;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                t = this.getAddress();
                return _context42.abrupt("return", this.restClient.getBalance(t.toString()));

              case 2:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "getBalanceLowerBounds",
    value: function getBalanceLowerBounds() {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this.waitUntilSynced();

              case 2:
                return _context43.abrupt("return", this.utxos.reduce(function (t, e) {
                  return t + e.satoshis;
                }, 0));

              case 3:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "getUtxosToSpend",
    value: function getUtxosToSpend(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44() {
        var _t6, _e12, _ref62;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return this.waitUntilSynced();

              case 2:
                for (_t6 = this.utxos.length - 1; _t6 > 0; _t6 -= 1) {
                  _e12 = Math.floor(Math.random() * (_t6 + 1));
                  _ref62 = [this.utxos[_e12], this.utxos[_t6]];
                  this.utxos[_t6] = _ref62[0];
                  this.utxos[_e12] = _ref62[1];
                }

                return _context44.abrupt("return", this.getUtxosWithSatoshis(t));

              case 4:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "getUtxosWithSatoshis",
    value: function getUtxosWithSatoshis(t) {
      var e = 0;
      var n = [];
      var s = 0;

      for (; e < t && s < this.utxos.length;) {
        n.push(this.utxos[s]), e += this.utxos[s].satoshis, s += 1;
      }

      if (e >= t) return n;
      throw new Error("Insufficient balance in address ".concat(this.getAddress().toString(), " on ").concat(g.NETWORK, " ").concat(g.CHAIN, ". Found ").concat(e, ", required ").concat(t, "."));
    }
  }, {
    key: "fundAndSendTransaction",
    value: function fundAndSendTransaction(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45() {
        var n, s, i, r;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                t.feePerKb(g.DEFAULT_FEE);
                n = t._estimateFee() + 100;
                _context45.next = 4;
                return this.getUtxosToSpend(t._getOutputAmount() - t._getInputAmount() + n);

              case 4:
                s = _context45.sent;
                s.forEach(function (e) {
                  return t.from(e);
                }), t.change(this.getAddress()), t.sign(this.getPrivateKey());
                _context45.next = 8;
                return this.restClient.sendTransaction(t, e);

              case 8:
                i = _context45.sent;
                this.utxos = this.utxos.filter(function (t) {
                  return !s.includes(t);
                });
                r = t.getChangeOutput();
                return _context45.abrupt("return", (r && this.utxos.push({
                  txId: t.getTxId(),
                  vout: t.getChangeIndex(),
                  satoshis: r.satoshis,
                  amount: r.satoshis / 1e8,
                  scriptPubKey: r.script.toHex()
                }), i));

              case 12:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "send",
    value: function send(t, e) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        var n;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                n = new Ot(this.chain, this.network).to(e, t);
                return _context46.abrupt("return", this.fundAndSendTransaction(n));

              case 2:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "chain",
    get: function get() {
      return this.restClient.chain;
    }
  }, {
    key: "network",
    get: function get() {
      return this.restClient.network;
    }
  }], [{
    key: "getHdPrivateKey",
    value: function getHdPrivateKey() {
      return new jt();
    }
  }]);

  return Ct;
}();

var Bt;

if ("undefined" == typeof window) {
  var _require = require("node-localstorage"),
      _t7 = _require.LocalStorage;

  Bt = new _t7("./uls-scratch");
} else void 0 !== window.localStorage && (Bt = window.localStorage);

var Nt = Bt;

var kt =
/*#__PURE__*/
function () {
  function kt() {
    _classCallCheck(this, kt);
  }

  _createClass(kt, null, [{
    key: "serialize",
    value: function serialize(t) {
      return JSON.stringify(Object.entries(t));
    }
  }, {
    key: "deserialize",
    value: function deserialize(t, e) {
      var n = e ? new e() : {};
      return JSON.parse(t).forEach(function (_ref63) {
        var _ref64 = _slicedToArray(_ref63, 2),
            t = _ref64[0],
            e = _ref64[1];

        n[t] = e;
      }), n;
    }
  }, {
    key: "set",
    value: function set(t) {
      if (void 0 === t._rev) throw new Error("Rev not set in Cache.set");
      var e = "Object" === t.constructor.name ? JSON.stringify({
        data: kt.serialize(t)
      }) : JSON.stringify({
        data: kt.serialize(t),
        clazz: t.constructor.toString()
      });
      return Nt.setItem(t._rev, e), t._rev;
    }
  }, {
    key: "get",
    value: function get(t) {
      var _ref65 = JSON.parse(Nt.getItem(t || "")) || {},
          e = _ref65.data,
          n = _ref65.clazz;

      if (e) {
        var _t8 = "string" == typeof n ? eval("(".concat(n, ")")) : void 0;

        return this.deserialize(e, _t8);
      }

      return null;
    }
  }]);

  return kt;
}();

var Ut =
/*#__PURE__*/
function () {
  function Ut(t, e) {
    _classCallCheck(this, Ut);

    this.chain = t, this.network = e;
  }

  _createClass(Ut, [{
    key: "get",
    value: function get(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        var _this14 = this;

        var e, _t$split15, _t$split16, n, s, i, r, c, _r$c$obj, a, u, d, h, p, l, f, g, w, _, v, _t9, _t10, m, b;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                e = kt.get(t);

                if (!e) {
                  _context48.next = 3;
                  break;
                }

                return _context48.abrupt("return", e);

              case 3:
                _t$split15 = t.split(":"), _t$split16 = _slicedToArray(_t$split15, 2), n = _t$split16[0], s = _t$split16[1];
                _context48.next = 6;
                return Ot.fromTxId(n, this.chain, this.network);

              case 6:
                i = _context48.sent;
                _context48.next = 9;
                return i.fetchOutputData();

              case 9:
                r = i.outputData;
                c = r[0].__index;
                _r$c$obj = r[c.obj], a = _r$c$obj.__cls, u = _r$c$obj.__func, d = _r$c$obj.__args;
                _context48.next = 14;
                return i.getVirtualInputs();

              case 14:
                h = _context48.sent;
                _context48.next = 17;
                return Promise.all(Object.values(c).map(function (t) {
                  return o(_this14, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee47() {
                    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
                      while (1) {
                        switch (_context47.prev = _context47.next) {
                          case 0:
                            return _context47.abrupt("return", h[t] ? this.get(h[t]) : Promise.resolve({}));

                          case 1:
                          case "end":
                            return _context47.stop();
                        }
                      }
                    }, _callee47, this);
                  }));
                }));

              case 17:
                p = _context48.sent;
                l = Object.keys(c).map(function (t, e) {
                  return [t, p[e]];
                });
                f = Object.fromEntries(l);
                g = f.obj;
                delete f.obj;
                w = Object.entries(f).reduce(function (t, _ref66) {
                  var _ref67 = _slicedToArray(_ref66, 2),
                      e = _ref67[0],
                      n = _ref67[1];

                  return Number.isNaN(parseInt(e, 10)) || (t[parseInt(e, 10)] = n), t;
                }, []);
                _ = Q(w, d);

                if ("constructor" === u) {
                  _t9 = eval("(".concat(a, ")"));
                  g = _construct(_t9, _toConsumableArray(_));
                } else {
                  _t10 = g[u].bind(g);
                  v = Reflect.apply(_t10, g, _);
                }

                m = c;
                Object.entries(m).forEach(function (_ref68) {
                  var _ref69 = _slicedToArray(_ref68, 2),
                      t = _ref69[0],
                      e = _ref69[1];

                  "obj" === t && K(g, r, e, n), K("res" === t ? v : w[t], r, e, n);
                });
                b = g._rootId || "".concat(n, ":").concat(m.obj);
                return _context48.abrupt("return", (A([g, v].concat(_toConsumableArray(w)), b), [g, v].concat(_toConsumableArray(w)).filter(function (t) {
                  return !y(t);
                }).map(kt.set), [].concat(_toConsumableArray(w), [g, v])[s]));

              case 29:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
  }]);

  return Ut;
}();

var _s$default5 = s.default,
    $t = _s$default5.Mnemonic,
    Kt = _s$default5.PublicKey;

var Dt =
/*#__PURE__*/
function () {
  function Dt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Dt);

    var e = t.seed,
        _t$chain = t.chain,
        n = _t$chain === void 0 ? g.CHAIN : _t$chain,
        _t$network = t.network,
        s = _t$network === void 0 ? g.NETWORK : _t$network,
        _t$mnemonic = t.mnemonic,
        i = _t$mnemonic === void 0 ? new $t(e) : _t$mnemonic,
        r = t.wocApiKey,
        _t$path = t.path,
        o = _t$path === void 0 ? "m/44'/0'/0'/0" : _t$path,
        _t$passphrase = t.passphrase,
        c = _t$passphrase === void 0 ? "" : _t$passphrase;
    if (!n || !["BSV", "BCH"].includes(n)) throw new Error("Please set 'chain' to 'BSV' or 'BCH' when creating a computer instance");
    if (!s || !["livenet", "testnet"].includes(s)) throw new Error("Please set 'network' to 'testnett' or 'livenet' when creating a computer instance");
    if (!i) throw new Error("Please set 'seed' to a valid BIP 39 mnemonic string when creating a computer instance");
    this.restClient = new dt(n, s, r);
    var _t$db = t.db,
        a = _t$db === void 0 ? new xt(new Ct(i, this.restClient, {
      path: o,
      passphrase: c
    })) : _t$db;
    this.db = a, this.reader = new Ut(this.chain, this.network);
  }

  _createClass(Dt, [{
    key: "new",
    value: function _new(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49() {
        var n, s, i, r;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                if (t) {
                  _context49.next = 2;
                  break;
                }

                throw new Error("Please enter a valid Class");

              case 2:
                n = new tt(this.db);
                s = Dt.parseContract(t);
                i = new Proxy(s, n);
                _context49.next = 7;
                return _construct(i, _toConsumableArray(e));

              case 7:
                r = _context49.sent;
                return _context49.abrupt("return", new Proxy(r, n));

              case 9:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
  }, {
    key: "sync",
    value: function sync(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee50() {
        var e, n;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                X(t);
                _context50.next = 3;
                return this.reader.get(t);

              case 3:
                e = _context50.sent;
                n = new tt(this.db);
                return _context50.abrupt("return", new Proxy(e, n));

              case 6:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    }
  }, {
    key: "getOwnedRevs",
    value: function getOwnedRevs() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.db.wallet.getPublicKey();
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51() {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                return _context51.abrupt("return", this.db.wallet.restClient.getOwnedRevs(t));

              case 1:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
    }
  }, {
    key: "getRevs",
    value: function getRevs() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.db.wallet.getPublicKey();
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee52() {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return this.db.wallet.restClient.getOwnedRevs(t);

              case 2:
                _context52.t0 = function (_ref70) {
                  var t = _ref70.txId,
                      e = _ref70.virtualIndex;
                  return "".concat(t, ":").concat(e);
                };

                return _context52.abrupt("return", _context52.sent.map(_context52.t0));

              case 4:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
    }
  }, {
    key: "getLatestRev",
    value: function getLatestRev(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                return _context53.abrupt("return", this.db.wallet.restClient.getLatestRev(t));

              case 1:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    }
  }, {
    key: "chain",
    get: function get() {
      return this.db.chain;
    }
  }, {
    key: "network",
    get: function get() {
      return this.db.network;
    }
  }], [{
    key: "parseContract",
    value: function parseContract(t) {
      if ("string" == typeof t) {
        var _e13 = t.startsWith("export ") ? t.slice(7) : t;

        var n = _e13.startsWith("default ") ? _e13.slice(8) : _e13;
        return eval("(".concat(n, ")"));
      }

      return t;
    }
  }]);

  return Dt;
}();

var At = function At(_ref71) {
  var t = _ref71.data;

  try {
    if ("eval" === t.cmd) {
      var _e14 = eval(t.string);

      window.parent.postMessage({
        res: _e14
      }, "*");
    } else {
      if ("apply" !== t.cmd) throw new Error("Unrecognized cmd in sandbox. " + t.cmd);
      {
        var _t$string = t.string,
            _e15 = _t$string.serialized,
            n = _t$string.func,
            s = _t$string.args,
            _i10 = _t$string.clazz;

        var _r4 = eval("(".concat(_i10, ")"));

        var _o3 = new _r4();

        JSON.parse(_e15).map(function (_ref72) {
          var _ref73 = _slicedToArray(_ref72, 2),
              t = _ref73[0],
              e = _ref73[1];

          return _o3[t] = e;
        });

        var _c3 = _o3[n].apply(_o3, _toConsumableArray(s));

        window.parent.postMessage({
          res: _c3,
          obj: _o3
        }, "*");
      }
    }
  } catch (t) {
    window.parent.postMessage({
      err: t.message
    }, "*");
  }
};

var Rt = function Rt(t) {
  return new Promise(function (e) {
    return setTimeout(e, t);
  });
};

var Ht = function Ht() {
  return "undefined" != typeof window && void 0 !== window.document;
};

var Mt = function Mt() {
  return "undefined" != typeof process && null != process.versions && null != process.versions.node;
};

var Lt =
/*#__PURE__*/
function () {
  function Lt() {
    _classCallCheck(this, Lt);

    this.isInitialized = !1, this.iframe = this.addIframe(At.toString());
  }

  _createClass(Lt, [{
    key: "addIframe",
    value: function addIframe(t) {
      var _this15 = this;

      var e = document.createElement("iframe");
      if (!e) throw new Error("could not create iframe");
      e.setAttribute("sandbox", "allow-scripts"), e.setAttribute("style", "display: none;"), e.onload = function () {
        _this15.isInitialized = !0;
      };
      var n = "<script type=\"module\" crossorigin=\"anonymous\">window.addEventListener('message', ".concat(t, ")</script>");
      if (e.src = "data:text/html;base64," + btoa(n), !document || !document.body) throw new Error("document body not found");
      return document.body.appendChild(e), e;
    }
  }, {
    key: "sendToFrame",
    value: function sendToFrame(t) {
      this.isInitialized && this.iframe.contentWindow.postMessage(t, "*");
    }
  }, {
    key: "eval",
    value: function _eval(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                if (this.isInitialized) {
                  _context54.next = 5;
                  break;
                }

                _context54.next = 3;
                return Rt(100);

              case 3:
                _context54.next = 0;
                break;

              case 5:
                return _context54.abrupt("return", (this.sendToFrame({
                  cmd: "eval",
                  string: t
                }), new Promise(function (t, e) {
                  window.addEventListener("message", function (_ref74) {
                    var n = _ref74.data;
                    n.res ? t(n.res) : e(n.err);
                  });
                })));

              case 6:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "apply",
    value: function apply(t, e, n) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee55() {
        var s, i;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                if (this.isInitialized) {
                  _context55.next = 5;
                  break;
                }

                _context55.next = 3;
                return Rt(100);

              case 3:
                _context55.next = 0;
                break;

              case 5:
                s = JSON.stringify(Object.entries(t));
                i = t.constructor.toString();
                return _context55.abrupt("return", (this.sendToFrame({
                  cmd: "apply",
                  string: {
                    serialized: s,
                    func: e,
                    args: n,
                    clazz: i
                  }
                }), new Promise(function (t, e) {
                  window.addEventListener("message", function (_ref75) {
                    var n = _ref75.data;
                    n.res ? t(n) : e(n.err);
                  });
                })));

              case 8:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));
    }
  }]);

  return Lt;
}();

var zt =
/*#__PURE__*/
function () {
  function zt() {
    _classCallCheck(this, zt);
  }

  _createClass(zt, [{
    key: "eval",
    value: function _eval(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee56() {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", eval(t));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56);
      }));
    }
  }, {
    key: "apply",
    value: function apply(t, e, n) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57() {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", {
                  res: t[e].apply(t, _toConsumableArray(n)),
                  obj: t
                });

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57);
      }));
    }
  }]);

  return zt;
}();

var Ft =
/*#__PURE__*/
function () {
  function Ft() {
    _classCallCheck(this, Ft);

    if (console.log("Using ".concat(Ht() ? "browser" : "node", " sandbox")), Ht()) this.sandbox = new Lt();else {
      if (!Mt()) throw new Error("Unrecognized computing environment");
      this.sandbox = new zt();
    }
  }

  _createClass(Ft, [{
    key: "eval",
    value: function _eval(t) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                return _context58.abrupt("return", this.sandbox.eval(t));

              case 1:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "apply",
    value: function apply(t, e, n) {
      return o(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee59() {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                return _context59.abrupt("return", this.sandbox.apply(t, e, n));

              case 1:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    }
  }]);

  return Ft;
}();

exports.Sandbox = Ft, exports.default = Dt;